module.exports = __webpack_public_path__ + "img/MP3.273a5c97.png";